/* eslint-disable no-extra-boolean-cast */
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"cpL-Hr6ekoM3MvXiGfizJ"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

const sentryDSNProd =
  "https://30aee5d198723cb7bea4b02954e245bd@o4507935226134528.ingest.de.sentry.io/4507935228821584";
const sentryDSNDev =
  "https://b730559806ff04e18b452314806bae4d@o4507935226134528.ingest.de.sentry.io/4508887562059856";

const sentryDSN =
  process.env.NODE_ENV === "production" ? sentryDSNProd : sentryDSNDev;

Sentry.init({
  dsn: sentryDSN,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: !!process.env.FORCE_SENTRY ? 1 : 0.75,

  // Define how likely Replay events are sampled.
  replaysSessionSampleRate: 0.05,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 0.33,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  enabled: process.env.NODE_ENV === "production" || !!process.env.FORCE_SENTRY,
});
